import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { ThinkingOrb, type OrbState } from 'thinking-orbs';

const STATES: OrbState[] = ['working', 'searching', 'solving', 'listening', 'composing', 'shaping'];

const LABELS = [
  'Evaluando',
  'Analizando',
  'Pensando',
  'Procesando',
  'Cargando',
  'Buscando',
  'Calculando',
  'Interpretando',
  'Sintetizando',
  'Correlacionando',
  'Ponderando',
  'Diagnosticando',
];

function pickRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

interface LoadingOrbProps {
  /** 64 = bloque/página con etiqueta; 20 = inline en botones, sin etiqueta. */
  size?: 64 | 20;
  /** Alto mínimo del contenedor cuando size=64. */
  minHeight?: string | number;
}

export function LoadingOrb({ size = 64, minHeight = '60vh' }: LoadingOrbProps) {
  const state = useMemo(() => pickRandom(STATES), []);
  const label = useMemo(() => pickRandom(LABELS), []);

  if (size === 20) {
    return <ThinkingOrb state={state} size={20} aria-label={label} />;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={1.5}
      minHeight={minHeight}
    >
      <ThinkingOrb state={state} size={64} aria-label={label} />
      <Typography variant="body2" color="text.secondary">
        {label}…
      </Typography>
    </Box>
  );
}
